import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-digitale-intelligenza-artificiale',
    templateUrl: './digitale-intelligenza-artificiale.component.html',
    standalone: false
})
export class DigitaleIntelligenzaArtificialeComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Finanziamenti digitalizzazione PMI: scopri bandi per tecnologie 4.0, AI, cybersecurity e cloud. Incentivi PNRR con crediti d’imposta Transizione 4.0";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Digitalizzazione & Intelligenza Artificiale – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }

}